import { get, post } from '@/lib/api';
import type { SetupAction, SetupState } from '@/types';

/** GET /api/setup returns the SetupState object directly, no envelope. */
export const fetchSetup = (signal?: AbortSignal) =>
  get<SetupState>('/api/setup', undefined, signal);

/** POST /api/setup records a choice about the guide and returns the new state. */
export const setupAction = (action: SetupAction) =>
  post<SetupState>('/api/setup', typeof action === 'string' ? { action } : action);
